// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter__1wbbR","counter__timer":"Counter_counter__timer__2zqV0","resend-sms":"Counter_resend-sms__2WaSb"};